(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracProviderDialogController', NasracProviderDialogController);

    NasracProviderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracProvider'];

    function NasracProviderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracProvider) {
        var vm = this;

        vm.nasracProvider = entity;
        vm.isSave=false;
        if(vm.nasracProvider.id==null)
        {
            vm.isSave=true;
        }
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            if(vm.isSave) {
                angular.element('.form-group:eq(0)>input').focus();
            }
            else {
                angular.element('.form-group:eq(1)>input').focus();
            }
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.isSave) {
                NasracProvider.save(vm.nasracProvider, onSaveSuccess, onSaveError);
            } else {
                NasracProvider.update(vm.nasracProvider, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracProviderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
